module.exports = __webpack_public_path__ + "img/play-ico-small.bdaa203b.svg";